import {
  Box,
  Button as MuiButton,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import styled from "@emotion/styled";
import { useFormAccordo } from "./ContextAccordo";
import { NumericFormat } from "react-number-format";
import { Add } from "@mui/icons-material";
import GaranzieModale from "./lib/GaranzieModale";

const TableWrapper = styled.div`
  overflow-y: auto;
  max-width: calc(100vw - ${(props) => props.theme.spacing(12)});
`;

const Button = styled(MuiButton)`
  margin: 0 8px;
`;

const Garanzie = () => {
  const { formState, dispatch } = useFormAccordo();
  const [openModale, setOpenModale] = useState(false);
  /* console.log(formState); */
  return (
    <>
      <Box textAlign="end">
        <Tooltip title="Aggiungi garanzia">
          <Button variant="contained" onClick={() => setOpenModale(true)}>
            <Add />
          </Button>
        </Tooltip>
      </Box>
      <GaranzieModale open={openModale} setOpen={setOpenModale} />
      <Paper sx={{ mt: 4 }}>
        <TableWrapper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">Garanzia / Accessorio</TableCell>
                <TableCell align="center">Prezzo</TableCell>
                <TableCell align="center">Obbligatorio</TableCell>
                <TableCell align="center">Visibile</TableCell>
                <TableCell align="center">Frazionamento</TableCell>
                <TableCell align="center">Incluso</TableCell>
                <TableCell align="center">Garanzia Ratino</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {formState.garanzie.map((row) => (
                <TableRow key={row.idGaranzia}>
                  <TableCell>
                    <Typography sx={{ width: 200 }}>{row.nome}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <NumericFormat
                      id={`${row.idGaranzia}LabelPrezzo`}
                      customInput={TextField}
                      prefix="€"
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      sx={{ width: 100 }}
                      valueIsNumericString
                      value={row.prezzo}
                      onValueChange={(e) => {
                        console.log(e);
                        dispatch({
                          type: "set_garanzie",
                          id: row.idGaranzia,
                          payload: {
                            ...row,
                            prezzo: e.value,
                          },
                        });
                      }}
                    />
                  </TableCell>
                  {[
                    "obbligatorio",
                    "visibile",
                    "frazionamento",
                    "incluso",
                    "garanziaRatino",
                  ].map((el) => (
                    <TableCell align="center" key={el}>
                      <Switch
                        id={`${row.idGaranzia}Label${el}`}
                        checked={row[el] === 1 ? true : false}
                        onChange={(e) =>
                          dispatch({
                            type: "set_garanzie",
                            id: row.idGaranzia,
                            payload: {
                              ...row,
                              [el]: e.target.checked ? 1 : 0,
                            },
                          })
                        }
                        sx={{
                          "&.MuiSwitch-root .MuiSwitch-switchBase": {
                            color: "#ccc",
                          },
                          "&.MuiSwitch-root .Mui-checked": {
                            color: "#407ad6",
                          },
                        }}
                      />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableWrapper>
      </Paper>
    </>
  );
};

export default Garanzie;
